import React, { useEffect, useState } from "react";
import IconError from "../assets/images/IconError";
const ErrorMessage = ({ error = "", className = "", datetimestamp,duration = 3000, }) => {
  const [alert, setAlert] = useState(true);

  useEffect(() => {
    setAlert(true);
    const timer = setTimeout(() => {
      setAlert(false);
    }, duration);
  }, [datetimestamp]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlert(false);
    }, duration);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {alert && (
        <div className={`inline-message error mt8 ${className}`}>
          <IconError className="icon" />
          {error}
        </div>
      )}
    </>
  );
};

export default ErrorMessage;
